import { PageHeader } from "../components/ui.js";
import { AgentChat } from "../components/AgentChat.js";

export function Agente() {
  return (
    <div className="mx-auto max-w-4xl">
      <PageHeader title="Agente IA" subtitle="Perguntas em linguagem natural sobre os dados (somente leitura, com citação da fonte)" />
      <AgentChat />
    </div>
  );
}
